import { type Module } from 'mini-common-schema';

/**
 * Based on the URL pathname determine the Module to load
 */
export const determineModule = (): Module => {
    const pathname = window?.location?.pathname;

    if (pathname) {
        if (pathname.indexOf('/calendar') === 0) {
            return 1;
        } else if (pathname.indexOf('/people') === 0) {
            return 2;
        } else if (pathname.indexOf('/host') == 0) {
            // OWS does not recognize todo as a module. BigOWA also uses host.
            // If new hosts come in, we can add subroutes to host
            return 10;
        }
    }

    return 0;
};
